import React from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css"; // Import Swiper styles
import "swiper/css/pagination"; // Import Swiper pagination styles
import "swiper/css/navigation"; // Import Swiper navigation styles
import SwiperCore from "swiper";
import { Autoplay, Navigation, Pagination } from "swiper/modules";
import { motion } from "framer-motion";

// Install Swiper modules
SwiperCore.use([Pagination, Navigation]);

function Testimonial({ logoSrc, sentence, name, location, title }) {
  return (
    <article className="flex flex-col justify-center pb-4 w-full bg-white rounded-xl shadow-xl max-md:mt-8">
      <div className="flex justify-center items-center px-16 py-3.5 bg-light-indigo border-dark-indigo border-b-[3px] rounded-t-xl shadow-sm max-md:px-5">
        <img
          alt="Client Logo"
          src={logoSrc}
          className="max-w-full aspect-[7.14] w-[152px]"
        />
      </div>
      <blockquote className="mx-4 mt-2 text-lg leading-5 light-title max-md:mx-2.5">
        <h2 className="text-[21px] font-medium">{title}</h2>
        <p className="dark-testimonial-text">
          <span className="text-5xl lowercase">“</span>
          {sentence}
        </p>
        <footer className="mt-3 float-right">
          <strong className="text-xl font-medium light-title">{name}</strong>
          <span className="block font-medium light-title">{location}</span>
        </footer>
      </blockquote>
    </article>
  );
}

const testimonials = [
  {
    logoSrc:
      "https://cdn.builder.io/api/v1/image/assets/TEMP/5d0f3d28d63b0ed377625cba0fa9c6adc22cb0bedce7b3936e65aa2e9fc585e1?apiKey=3756b57bedc84c2cbd55485bb12ec63c&",
    title: "EXPERTEFY are the True Professionals and Experts!",
    sentence:
      "Solid communication and went to bat for competitive pricing. Sid, the account manager, even stayed on the line to ensure there was a connected bridge between expertise, professionalism & rapport. Out of the 4 different firms I've worked with EXPERTEFY stepped into my #1 position!",
    name: "Bradley",
    location: "United States",
  },
  {
    logoSrc:
      "https://cdn.builder.io/api/v1/image/assets/TEMP/59c8aaffcf471959a123ebf4b4a59039cf8814d579112e5c72677ebbe0ca1c40?apiKey=3756b57bedc84c2cbd55485bb12ec63c&",
    title: "EXPERTEFY - Highly Recommended",
    sentence:
      "I was contacted by EXPERTEFY as an industry subject matter expert to provide advice to an industry company within my field. I was very impressed by the positive level of contact prior to and following the arrangement. This resulted in their client having the latest information and industry trends explained within a comfortable environment for all concerned. I look forward to supporting EXPERTEFY again.",
    name: "Paul",
    location: "United Kingdom",
  },
  {
    logoSrc:
      "https://cdn.builder.io/api/v1/image/assets/TEMP/f88115be6c6c5e6a9c98cdaa1f28b6e5e71fab787c494fbc0dcced07a53295ba?apiKey=3756b57bedc84c2cbd55485bb12ec63c&",
    title: "Simple and transparent process",
    sentence:
      "I was contacted … to help in the form of a phone consultation. The consulting initiation and selection process was simple and transparent. I was properly guided throughout the process. The payment was transferred with in the agreed time period.",
    name: "Mohammed",
    location: "United Arab Emirates",
  },
  {
    logoSrc:
      "https://cdn.builder.io/api/v1/image/assets/TEMP/f88115be6c6c5e6a9c98cdaa1f28b6e5e71fab787c494fbc0dcced07a53295ba?apiKey=3756b57bedc84c2cbd55485bb12ec63c&",
    title: "Knowledge sharing satisfactory experience",
    sentence:
      "I was contacted by EXPERTEFY … with a request for an expert consultation on electrical distribution infrastructure. As I have vast experience on the subject, I agreed to have a one hour consultation with a EXPERTEFY customer that needed an overview of the latest trends in this market. The discussion was useful to the client and I had great satisfaction to share my knowledge and insights.",
    name: "Juan",
    location: "France",
  },
];

const ClientsTestimonials = () => {
  return (
    <motion.section
      initial={{ opacity: 0, translateY: -200  }}
      whileInView={{ opacity: 1, translateY: 0 }}
      transition={{ duration: 0.5, delay: 0.8, type: "spring" }}
      viewport={{ once: true }}
    
      className="flex flex-col items-center px-5 mt-20 w-full max-md:mt-10 max-md:max-w-full">
      <div className="text-base leading-4 text-center light-title">
        <span className="text-lg text-color">TESTIMONIALS</span>
        <br />
        <span className="text-3xl sm:text-5xl font-medium light-title">
          What Our Experts Say
        </span>
        <br />
      </div>
      
      <Swiper
        autoplay={{
          delay: 2500,
          disableOnInteraction: false,
        }}
        speed={1000}
        spaceBetween={30} // Add space between slides
        slidesPerView={1} // Number of slides visible at once
        navigation={true}
        loop={true}
        pagination={{ clickable: true }}
        modules={[Autoplay, Navigation]}
        className="mt-6 w-full max-w-[1120px] max-md:max-w-full"
        breakpoints={{
          // when window width is <= 768px (tablet)
          768: {
            slidesPerView: 2,
            spaceBetween: 40,
          },
          // when window width is <= 1024px (desktop)
          1024: {
            slidesPerView: 3,
            spaceBetween: 50,
          },
        }}
      >
        {testimonials.map((testimonial, index) => (
          <SwiperSlide key={index}>
            <Testimonial {...testimonial} />
          </SwiperSlide>
        ))}
      </Swiper>
    </motion.section>
  );
};

export default ClientsTestimonials;
